import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import firebase from 'firebase'
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
  withRouter
} from 'react-router-dom'


const config = {
  apiKey: "AIzaSyBKrVbvk12P3WpPnTBHdlC6d0U_4I71pus",
  authDomain: "auxcorde.com",
  databaseURL: "https://auxcorde-c5d5d.firebaseio.com",
  projectId: "auxcorde-c5d5d",
  storageBucket: "auxcorde-c5d5d.appspot.com",
  messagingSenderId: "841876085617"
};
firebase.initializeApp(config);

// const ololo = [
//   "doug",
//   "ears",
//   "colm",
//   "dan",
//   "danny",
//   "adam",
//   "adham",
//   "kidsuper",
//   "dek",
//   "1",
//   "2",
//   "3",
//   "4",
//   "5",
//   "6",
//   "7",
//   "8",
//   "9",
//   "10",
//   "apple",
//   "spotify",
//   "tidal",
//   "youtube",
//   "deezer",
//   "genius",
//   "pandora",
//   "soundcloud",
//   "google",
//   "amazon",
//   "russ",
//   "bugus",
//   "safagaw",
//   "lolozouai",
//   "alinabaraz",
//   "kehlani",
//   "joeybadass",
//   "kirkknight",
//   "dee",
//   "nyckcaution",
//   "proera",
//   "cinematic",
//   "flippdinero",
//   "jesushoncho",
//   "postmalone",
//   "khalid",
//   "billieeillish"
// ]

// const updates = {}

// ololo.forEach((value, i) => {
//   updates['Usernames/' + 'reserved' + i] = value
// })

// console.log(updates)

// firebase.database().ref().update(updates).
// then(() => console.log('updated'))

ReactDOM.render(
  <Router>
    <App />
  </Router>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js